$('a[name="1_h"]').on('click', function(){
  $('#hour_duration').val(1);
});
$('a[name="2_h"]').on('click', function(){
  $('#hour_duration').val(2);
});
$('a[name="3_h"]').on('click', function(){
  $('#hour_duration').val(3);
});
$('a[name="4_h"]').on('click', function(){
  $('#hour_duration').val(4);
});

